/* eslint-disable import/prefer-default-export */

export default async function init() {
}
